import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { SummaryComponent } from './features/summary/summary.component';
import { GeneralComponent } from './features/general/general.component';
import { ActivityListComponent } from './features/activity-list/activity-list.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'general', component: GeneralComponent },
  { path: 'activity-list', component: ActivityListComponent },
  { path: 'summary', component: SummaryComponent },
];
